/**
 * Created by Ella Ma on 07/12/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppState } from '../../../redux';
import { AuditLogActionTypes } from '../../../redux/actions/audit-log.actions';
import { FilterService } from '../../../tamalelibs/services/filter.service';
import { AuditFilterService } from '../../../tamalelibs/services/audit-filter.service';
import {
    FilterPanelConfig, FilterPanelActions,
    FilterPanelEvents
} from '../../../widgets/filter-item/filter-panel/filter-panel.view-model';
import { AuditLogFilterConfig, GridEventType, showOperatorsType, GridActionType } from './audit-log-filter.config';
import { FieldEventType, FieldConfig } from '../../../widgets/field-selector/field-selector.model';

@Component({
    selector: 'tam-audit-log-filter',
    templateUrl: './audit-log-filter.component.html',
    styleUrls: ['./audit-log-filter.component.scss']
})
export class AuditLogFilterComponent implements OnInit, OnDestroy {

    @Input() config: AuditLogFilterConfig;

    filterConfig: FilterPanelConfig;
    fieldConfig: FieldConfig;
    disabled = true;
    isProgressing = false;
    showSelector = true;

    private _destroySubscriptions: Array<Subscription> = [];
    private _filterSubject: Subject<any> = new Subject();
    private initPage = true;

    constructor(private _store: Store<AppState>,
        private _filterService: FilterService,
        private _auditFilterService: AuditFilterService) { }

    ngOnInit() {
        this.filterConfig = new FilterPanelConfig();
        this.fieldConfig = new FieldConfig();

        // init audit log filter, add four type
        this.initFilter();

        this._destroySubscriptions.push(
            this.config.actions$.pipe(
                filter((action) => action.type === GridActionType.changeObjectType)
            ).subscribe((action) => {
                this.disabled = false;
                this.isProgressing = false;
            })
        );

        this.stateSubject();
        this.filterConfigSubject();
        this.fieldConfigSubject();
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    initFilter() {
        ['User', 'Where', 'DateAndTime', 'Action'].forEach((data) => {
            const _filtersConfig = this._filterService.getNewFilterDefaultInstance(data, data,
                showOperatorsType.indexOf(data) === -1, true);
            _filtersConfig.tId = `audit_${data.toLowerCase()}`;
            if (data === 'DateAndTime') {
                _filtersConfig.value = '1 week';
                _filtersConfig.tId = `audit_datetime`;
            }
            this.filterConfig.filtersConfigList.push(_filtersConfig);
        });
        const advFilter = this._auditFilterService.parseAuditFilterSetting(this.filterConfig.filtersConfigList);
        this.config.events$.next({ type: GridEventType.initFilterParams, payload: advFilter });
        this.updateFilterState({ type: AuditLogActionTypes.ADD_FILTER_LIST });
    }

    stateSubject() {
        this._destroySubscriptions.push(
            this._filterSubject.subscribe((data) => {
                this._store.dispatch({
                    type: data.type,
                    payload: data.payload
                });
            })
        );
    }

    filterConfigSubject() {
        this._destroySubscriptions.push(
            this.filterConfig.events$.pipe(
                filter((data) => data.type === FilterPanelEvents.change || data.type === FilterPanelEvents.delete)
            ).subscribe((data) => {
                if (!this.initPage) {
                    this.disabled = false;
                    this.isProgressing = false;
                }
                this.initPage = false;
                this.filterConfig.filtersConfigList = [].concat(data.payload);
                this.updateFilterState({ type: AuditLogActionTypes.SET_FILTER_LIST });
            })
        );
    }

    fieldConfigSubject() {
        this._destroySubscriptions.push(
            this.fieldConfig.events$.pipe(
                filter(data => data.type === FieldEventType.select)
            ).subscribe((data) => {
                this.disabled = false;
                const filtersConfig = this._filterService.getNewFilterDefaultInstance(data.payload.text,
                    data.payload.value, showOperatorsType.indexOf(data.payload.text) === -1);
                this.filterConfig.filtersConfigList.push(filtersConfig);
                this.filterConfig.action$.next({ type: FilterPanelActions.addFilter, payload: [filtersConfig] });
                this.updateFilterState({ type: AuditLogActionTypes.ADD_FILTER_LIST, payload: [filtersConfig] });
            })
        );
    }

    updateFilterState(data) {
        this._filterSubject.next({ type: data.type, payload: data.payload || this.filterConfig.filtersConfigList });
    }

    onApply() {
        this.isProgressing = true;
        this.disabled = true;
        const advFilter = this._auditFilterService.parseAuditFilterSetting(this.filterConfig.filtersConfigList);
        this.config.events$.next({ type: GridEventType.apply, payload: advFilter });
    }

}
